import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem, IonInput, IonButton, IonIcon, IonSpinner, IonNote, IonButtons } from '@ionic/angular/standalone';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { TranslateService } from 'src/assets/translate.service';
import { AuthService } from '../../services/auth.service';
import { ModalService } from '../../services/modal.service';
import { Subscription } from 'rxjs';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';

@Component({
  selector: 'app-forgot-password-modal',
  templateUrl: './forgot-password-modal.component.html',
  styleUrls: ['./forgot-password-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule, FormsModule, TranslatePipe,
    IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem,
    IonInput, IonButton, IonIcon, IonSpinner, IonButtons
  ]
})
export class ForgotPasswordModalComponent implements OnDestroy {
  email = '';
  resetError = '';
  resetSuccess = '';
  isSubmitting = false;

  private languageChangeSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private modalService: ModalService,
    private translateService: TranslateService
  ) {
    addIcons({ close });
    this.languageChangeSubscription = this.translateService.languageChanged.subscribe(() => {
      this.resetError = '';
      this.resetSuccess = '';
    });
  }

  resetPassword(): void {
    if (!this.email || this.isSubmitting) return;

    this.isSubmitting = true;
    this.resetError = '';
    this.resetSuccess = '';

    this.authService.resetPassword(this.email).subscribe({
      next: () => {
        this.resetSuccess = this.translateService.instant('PASSWORD_RESET_SUCCESS');
        this.isSubmitting = false;
      },
      error: (error: any) => {
        if (error instanceof Error && error.message === 'EMAIL_NOT_FOUND') {
          this.resetError = 'This email address is not registered in our system.';
        } else if (error instanceof Error) {
          this.resetError = error.message;
        } else {
          this.resetError = this.translateService.instant('PASSWORD_RESET_ERROR');
        }
        this.isSubmitting = false;
      }
    });
  }

  async backToLogin(): Promise<void> {
    await this.modalService.dismiss();
    this.modalService.openLoginModal();
  }

  closeModal(): void {
    this.modalService.dismiss();
  }

  ngOnDestroy(): void {
    this.languageChangeSubscription.unsubscribe();
  }
}